// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"_2uY-C","lists":"_95G_4"};